import imageProductDefault from 'Static/images/productCover.jpg'

export const getProductImage = function (product) {
  return {
    id: product.image?.id ?? 0,
    src: product.image?.url ?? imageProductDefault,
  }
}
